<div class="page-head" *ngIf="breadcrumbs.length > 0">
    <div class="container-for-dress">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" *ngFor="let breadcrumb of breadcrumbs; let l = last">
            <a [routerLink]="breadcrumb.url.path" [queryParams]="breadcrumb.url.params">
              {{ breadcrumb.name }}
            </a>
          </li>
          <!-- <li class="breadcrumb-item"><a href="#">Library</a></li>
          <li class="breadcrumb-item active" aria-current="page">Data</li> -->
        </ol>
      </nav>
    </div><!--End Container-->
  </div><!--End Page-head-->
  